import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HybridAdapterUtility } from '../../Hybrid/hybrid-adapter.utility';
import { AgGridModule } from 'ag-grid-angular';
import { WeissmanSharedModule } from '../../Common/weissman-shared.module';
import { SharedPipesModule } from '../../UI-Lib/Pipes/shared-pipes.module';
import { AgGridLoadingOverlayComponent } from '../../Common/AgGrid/agGridLoadingOverlay.component';
import { BusyIndicatorModule } from '../../Busy-Indicator';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AgGridExtensionsModule } from '../../Compliance/AgGrid/agGridExtensions.module';
import { TaxFeedLogService } from './taxFeedLog.service';
import { TaxFeedLogRepository } from './taxFeedLog.repository';
import { TaxFeedLogListComponent } from './Tax-Feed-Log-List/taxFeedLogList.component';
import { TaxFeedLogListGridActionCellRendererComponent } from './Tax-Feed-Log-List/agGridActionCellRenderer.component';
import { TaxFeedLogDetailsModalComponent } from './Tax-Feed-Log-Details/taxFeedLogDetailsModal.component';
import { TaxFeedLogDetailsGridComponent } from './Tax-Feed-Log-Details/taxFeedLogDetailsGrid.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        WeissmanSharedModule,
        SharedPipesModule,
        BusyIndicatorModule.forRoot(),
        AgGridExtensionsModule,
        AgGridModule
    ],
    declarations: [
        TaxFeedLogListComponent,
        TaxFeedLogListGridActionCellRendererComponent,
        TaxFeedLogDetailsModalComponent,
        TaxFeedLogDetailsGridComponent
    ],
    providers: [
        TaxFeedLogService,
        TaxFeedLogRepository
    ],
    exports: []
})
export class TaxFeedLogModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('taxFeedLogList', TaxFeedLogListComponent);
        hybridAdapterUtility.downgradeNg2Component('taxFeedLogDetails', TaxFeedLogDetailsModalComponent);
        hybridAdapterUtility.downgradeNg2Component('taxFeedLogDetailsGrid', TaxFeedLogDetailsGridComponent);
    }
}
